import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addDevice, getDevices } from "../actions/deviceActions";
import { getUsersDevices } from "../actions/usersDevicesActions";
import { getUsersLogs } from "../actions/usersLogsActions";
class AddDeviceModal extends Component {
  state = {
    modal: false,
    name: "",
    macAddr: ""
  };

  static propTypes = {
    auth: PropTypes.object.isRequired,
    addDevice: PropTypes.func.isRequired,
    getDevices: PropTypes.func.isRequired
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();

    const newDevice = {
      deviceName: this.state.deviceName,
      deviceMAC: this.state.deviceMAC
    };

    //Add device via addDevice action
    this.props.addDevice(this.props.auth.user[0].username, newDevice);

    //Close Modal
    this.toggle();

    //get the device list for the user
    this.props.getDevices(this.props.auth.user[0].username);

    if (this.props.auth.user[0].isAdmin === "Yes") {
      this.props.getUsersDevices();
      this.props.getUsersLogs();
    }
  };

  render() {
    const { devices } = this.props.device;

    if (devices.length >= 5)
      return (
        <h3>
          You cannot have more than 5 devices. Please delete one from the list
          and then add the new one.{" "}
        </h3>
      );
    else
      return (
        <div>
          <Button
            color="primary"
            style={{ marginBottom: "2rem" }}
            onClick={this.toggle}>
            Add Device
          </Button>
          <Modal isOpen={this.state.modal} toggle={this.toggle}>
            <ModalHeader toggle={this.toggle}>
              {" "}
              Add to the Devices List{" "}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={this.onSubmit}>
                <FormGroup>
                  <Label for="deviceNames">Device Name</Label>
                  <Input
                    type="text"
                    name="deviceName"
                    id="deviceName"
                    placeholder="Add a wireless device"
                    onChange={this.onChange}
                  />
                  <br />
                  <Label for="deviceMACs">
                    MAC Address (Format: 00:11:22:33:44:55)
                  </Label>
                  <Input
                    type="text"
                    name="deviceMAC"
                    id="deviceMAC"
                    placeholder="MAC Address of your device"
                    pattern="^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$"
                    onChange={this.onChange}
                  />
                  <p>
                    <a href="https://its.truman.edu/get-help/">
                      {" "}
                      If you have trouble adding a device, contact Service
                      Center.
                    </a>
                  </p>

                  <Button color="primary" style={{ marginTop: "2rem" }} block>
                    Add Device
                  </Button>
                </FormGroup>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      );
  }
}

const mapStateToProps = state => ({
  device: state.device,
  auth: state.auth
});

export default connect(mapStateToProps, {
  addDevice,
  getDevices,
  getUsersDevices,
  getUsersLogs
})(AddDeviceModal);
